import BaseBrushTool from "component/molecules/viewport/tools/annotation/base/BaseBrushTool";
import math from "core/math";
import { getToolState, addToolState } from "component/toolManager/toolState.js";
import _ from "lodash";

import {
  modules,
  state
} from "component/molecules/viewport/toolStates/store.js";
import brushUtils from "./util/index.js";
import EVENTS from "core/customEvent/events.js";

import { default as triggerEvent } from "core/customEvent/triggerEvent.js";
import { getEnabledElement } from "component/toolManager/enabledElements.js";

import { getNewContext } from "component/molecules/viewport/draw/index.js";
const store = {
  modules,
  state
};

const { drawBrushPixels, getCircle } = brushUtils;

const brushModule = store.modules.brush;

function makeImageId(elementId, imageSOPUID) {
  const imageId = elementId + "_" + imageSOPUID;
  return imageId;
}

function getPointsbetweenTwoPoint(x0, y0, x1, y1) {
  var x0 = parseInt(x0);
  var y0 = parseInt(y0);
  var x1 = parseInt(x1);
  var y1 = parseInt(y1);

  var dx = Math.abs(x1 - x0);
  var dy = Math.abs(y1 - y0);
  var sx = x0 < x1 ? 1 : -1;
  var sy = y0 < y1 ? 1 : -1;
  var err = dx - dy;
  let arr = [];
  while (true) {
    arr.push({ x: x0, y: y0 }); // Do what you need to for this

    if (x0 === x1 && y0 === y1) break;
    var e2 = 2 * err;
    if (e2 > -dy) {
      err -= dy;
      x0 += sx;
    }
    if (e2 < dx) {
      err += dx;
      y0 += sy;
    }
  }
  return arr;
}

/**
 * @public
 * @class BrushTool
 * @memberof Tools.Brush
 * @classdesc Tool for drawing segmentations on an image.
 * @extends Tools.Base.BaseBrushTool
 */
export default class BrushTool extends BaseBrushTool {
  constructor(configuration = {}) {
    const defaultConfig = {
      name: "Brush",
      supportedInteractionTypes: ["Mouse", "Touch"],
      strategies: {
        //drawlineChain: _drawlineChain,
        overlapping: _overlappingStrategy,
        nonOverlapping: _nonOverlappingStrategy
      },
      //defaultStrategy: "drawlineChain",
      defaultStrategy: "overlapping",
      configuration: {}
    };
    const initialConfiguration = Object.assign(defaultConfig, configuration);

    super(initialConfiguration);

    this.color = "#ffff00"; // 기본 색상 노란색
    //this.mousedownCallback = this.handleMouseDown.bind(this);
    this.touchDragCallback = this._paint.bind(this);
    this.mouseDragCallback = this._paint.bind(this);
    this.mouseMoveCallback = this.handleMouseMove.bind(this);
    this.initialConfiguration = initialConfiguration;
  }
  setColor(color) {
    this.color = color;
  }
  mousedownCallback(evt) {
    this._lastImageCoords = evt.currentPoints.image;
  }
  /**
   * Called by the event dispatcher to render the image.
   *
   * @param {Object} evt - The event.
   * @returns {void}
   */
  renderBrush(evt) {
    const eventData = evt.detail;
    const viewport = eventData.viewport;

    let mousePosition;

    if (this._drawing) {
      mousePosition = this._lastImageCoords;
    } else if (this._mouseUpRender) {
      mousePosition = this._lastImageCoords;
      this._mouseUpRender = false;
    } else {
      mousePosition = store.state.mousePositionImage;
    }

    if (!mousePosition) {
      return;
    }

    const { rows, columns } = eventData.image;
    const { x, y } = mousePosition;
    if (x < 0 || x > columns || y < 0 || y > rows) {
      return;
    }

    // Draw the hover overlay on top of the pixel data
    const radius = brushModule.state.radius;
    ///const context = eventData.canvasContext;
    const context = getNewContext(eventData.canvas);
    const element = eventData.element;
    const drawId = brushModule.state.drawColorId;
    // const color = this._getBrushColor(drawId);
    const color = "#ffff00";
  
    context.setTransform(1, 0, 0, 1, 0, 0);

    const circleRadius = radius * viewport.scale;
    let mouseCoordsCanvas = null;
    const test = _.get(element, "className");
    if (test) {
      //mouseCoordsCanvas = pixelToCanvas(element, mousePosition);
      mouseCoordsCanvas = math.coordinate.pixelToCanvas(
        eventData,
        mousePosition
      );
      //enabledElement.needsRedraw = true;
    } else {
      mouseCoordsCanvas = math.coordinate.pixelToCanvas(element, mousePosition);
    }

    context.beginPath();
    context.strokeStyle = color;
    context.ellipse(
      mouseCoordsCanvas.x,
      mouseCoordsCanvas.y,
      circleRadius,
      circleRadius,
      0,
      0,
      2 * Math.PI
    );

    context.stroke();
    // console.log("drawn!");
  }

  /**
   *
   *
   * @memberof BrushTool
   */
  handleMouseMove = event => {
    // console.log("[BrushTool] handleMouseMove", event);
    this.renderBrush(event);
    const eventData = event.detail;
    const element = eventData.element;

    const test = _.get(element, "className");
    let enabledElement = null;
    if (test) {
      enabledElement = getEnabledElement(element);
    } else {
      enabledElement = getEnabledElement(element.element);
    }

    //let enabledElement = getEnabledElement(element);
    enabledElement.needsRedraw = true;
  };

  /**
   * Paints the data to the canvas.
   *
   * @private
   * @param  {Object} evt The data object associated with the event.
   * @returns {void}
   */
  _paint(evt) {
    _overlappingStrategy(evt, this._lastImageCoords);

    triggerEvent(
      evt.detail.element.element,
      EVENTS.MEASUREMENT_MODIFIED,
      evt.detail
    );

    const eventData = evt.detail;
    const element = eventData.element;

    if (_.get(element, "align")) {
      let enabledElement = getEnabledElement(element);
      enabledElement.needsRedraw = true;
    } else {
      let enabledElement = getEnabledElement(element.element);
      enabledElement.needsRedraw = true;
    }
    if (_.get(evt.currentPoints, "image")) {
      this._lastImageCoords = evt.currentPoints.image;
    } else {
      this._lastImageCoords = evt.detail.currentPoints.image;
    }
  }
}

function _overlappingStrategy(evt, lastImageCoords) {
  const eventData = evt.detail;
  const element = eventData.element.element;
  const { rows, columns } = eventData.image;
  const { x, y } = eventData.currentPoints.image;
  let toolState = getToolState(
    element,
    BaseBrushTool.getReferencedToolDataName()
  );

  if (!toolState) {
    addToolState(element, BaseBrushTool.getReferencedToolDataName(), {});
    toolState = getToolState(
      element,
      BaseBrushTool.getReferencedToolDataName()
    );
  }

  const toolData = toolState.data;

  if (x < 0 || x > columns || y < 0 || y > rows) {
    return;
  }

  //const radius = brushModule.state.radius;
  const radius = 1;

  if (
    typeof lastImageCoords !== undefined &&
    lastImageCoords !== null &&
    lastImageCoords !== undefined
  ) {
    const points = getPointsbetweenTwoPoint(
      lastImageCoords.x,
      lastImageCoords.y,
      x,
      y
    );
    for (let i = 0; i < points.length; i++) {
      const pointerArray = getCircle(
        radius,
        rows,
        columns,
        points[i].x,
        points[i].y
      );
      _drawMainColor(eventData, toolData, pointerArray);
    }
  } else {
    const pointerArray = getCircle(radius, rows, columns, x, y);
    _drawMainColor(eventData, toolData, pointerArray);
  }

  if (toolData[0].invalidated) {
    /// draw on canvas
  }
}

function _nonOverlappingStrategy(evt) {
  const eventData = evt.detail;
  const element = eventData.element;
  const { rows, columns } = eventData.image;
  const { x, y } = eventData.currentPoints.image;

  let toolState = getToolState(
    element,
    BaseBrushTool.getReferencedToolDataName()
  );

  if (!toolState) {
    addToolState(element, BaseBrushTool.getReferencedToolDataName(), {});
    toolState = getToolState(
      element,
      BaseBrushTool.getReferencedToolDataName()
    );
  }

  const toolData = toolState.data;
  const segmentationIndex = brushModule.state.drawColorId;

  if (x < 0 || x > columns || y < 0 || y > rows) {
    return;
  }

  const radius = brushModule.state.radius;
  const pointerArray = getCircle(radius, rows, columns, x, y);

  const numberOfColors = BaseBrushTool.getNumberOfColors();

  // If there is brush data in this region for other colors, delete it.
  for (let i = 0; i < numberOfColors; i++) {
    if (i === segmentationIndex) {
      continue;
    }

    if (toolData[i] && toolData[i].pixelData) {
      drawBrushPixels(pointerArray, toolData[i], columns, true);
      toolData[i].invalidated = true;
    }
  }

  _drawMainColor(eventData, toolData, pointerArray);
}

function _drawMainColor(eventData, toolData, pointerArray) {
  const shouldErase = _isCtrlDown(eventData);
  //const shouldErase =
  const columns = eventData.image.columns;
  const segmentationIndex = brushModule.state.drawColorId;

  if (shouldErase && !toolData[segmentationIndex]) {
    // Erase command, yet no data yet, just return.
    return;
  }

  if (!toolData[segmentationIndex]) {
    toolData[segmentationIndex] = {};
  }

  if (!toolData[segmentationIndex].pixelData) {
    const enabledElement = getEnabledElement(eventData.element.element);
    const enabledElementUID = enabledElement.uuid;

    const id = makeImageId(enabledElementUID, eventData.image.sopInstanceUID);
    // Clear cache for this color to avoid flickering.
    const imageBitmapCacheForElement = brushModule.getters.imageBitmapCacheForElement(
      //enabledElementUID
      id
    );

    if (imageBitmapCacheForElement) {
      imageBitmapCacheForElement[segmentationIndex] = null;
    }

    // Add a new pixelData array.
    toolData[segmentationIndex].pixelData = new Uint8ClampedArray(
      eventData.image.width * eventData.image.height
    );
  }

  const toolDataI = toolData[segmentationIndex];

  // Draw / Erase the active color.
  drawBrushPixels(pointerArray, toolDataI, columns, shouldErase);
  const context = getNewContext(eventData.element.canvas);
  //drawBrushOnCanvas(pointerArray, context, "red", eventData.element.element);
  toolDataI.invalidated = true;
}

function _isCtrlDown(eventData) {
  return (eventData.event && eventData.event.ctrlKey) || eventData.ctrlKey;
}

function _isRightMouseDown(event) {
  var isRightMB;
  event = event || window.event;

  if ("which" in event)
    // Gecko (Firefox), WebKit (Safari/Chrome) & Opera
    isRightMB = event.which == 3;
  else if ("button" in event)
    // IE, Opera
    isRightMB = event.button == 2;
}
